<template lang="pug">
  b-row
    .col-sm-12.col-md-12.col-lg-12.col-xl-12
      b-table#tblList.table-sm.table-hover.table-bordered(striped show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="list" :fields="fields" :per-page="perPage" :filter="filter")
        template(v-slot:cell(index)="row")
          span {{ row.index + 1 }}
        template(v-slot:cell(product)="row")
          b-link.text-uppercase(@click="getSportTypeWinlose(row.item)" v-if="row.item.product != 'ADJUSTMENT'") #[b {{ row.item.product }}]
          span(v-else) #[b {{ row.item.product }}]
          //- b-link.text-uppercase(@click="getSportTypeWinlose(row.item)") #[b {{ row.item.product }}]
        template(v-slot:cell(bet_count)="row")
          span #[b {{ row.item.bet_count }}]
        template(v-slot:cell(turnover)="row")
          span(:class="$helpers.getNumberClass(row.item.turnover)") #[b {{ row.item.turnover | currency }} ]
        template(v-slot:cell(valid_turnover)="row")
          span(:class="$helpers.getNumberClass(row.item.valid_turnover)") #[b {{ row.item.valid_turnover | currency }} ]
        template(v-slot:cell(gross_comm)="row")
          span(:class="$helpers.getNumberClass(row.item.gross_comm)") #[b {{ row.item.gross_comm | currency }} ]
        template(v-slot:thead-top="row")
          tr
            th.bg-grey-lighter(colspan="6")
            template(v-for="level in downlineLevel")
              th.text-center(colspan="3" :class="'bg-grey-transparent-'+level" v-if="level == 1") {{ $helpers.getUplineName(level) }}
            //- th.text-center.bg-grey-transparent-7(colspan="3") {{ $t("ui.company") }}
        template(v-slot:cell(member_winlose)="row")
          span(:class="$helpers.getNumberClass(row.item.member_winlose)") #[b {{ row.item.member_winlose | currency }} ]
        template(v-slot:cell(member_comm)="row")
          span(:class="$helpers.getNumberClass(row.item.member_comm)") #[b {{ row.item.member_comm | currency }} ]
        template(v-slot:cell(member_winlose_comm)="row")
          span(:class="$helpers.getNumberClass(row.item.member_winlose_comm)") #[b {{ row.item.member_winlose_comm | currency }} ]
        template(v-slot:bottom-row="row" v-if="list.length > 0")
          td.text-right(colspan="2")
            span #[b {{ $t("ui.grand_total") }} ]
          td.text-center
            span #[b {{ grandTotalBetCount }} ]
          td.text-right
            span(:class="$helpers.getNumberClass(grandTotalTurnover)")  #[b {{ grandTotalTurnover | currency }} ]
          td.text-right
            span(:class="$helpers.getNumberClass(grandTotalValidTurnover)")  #[b {{ grandTotalValidTurnover | currency }} ]
          td.text-right
            span(:class="$helpers.getNumberClass(grandTotalGrossCommission)")  #[b {{ grandTotalGrossCommission | currency }} ]
          td.text-right
            span(:class="$helpers.getNumberClass(grandTotalMemberWinlose)")  #[b {{ grandTotalMemberWinlose | currency }} ]
          td.text-right
            span(:class="$helpers.getNumberClass(grandTotalMemberCommission)")  #[b {{ grandTotalMemberCommission | currency }} ]
          td.text-right.bg-yellow-transparent-2
            span(:class="$helpers.getNumberClass(grandTotalMemberWinloseCommission)")  #[b {{ grandTotalMemberWinloseCommission | currency }} ]
</template>

<script>

export default {
  props: {
    list: {
      type: Array,
      default: function () { return [] }
    }
  },
  data() {
    return {
      downlineLevel: this.$store.getters.accountType,
      showTotal: false,
      filter: null,
      sortBy: "product",
      sortDesc: true,
      currentPage: 1,
      totalRows: 0
    }
  },
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "align-middle text-center",
          thClass: "bg-grey-lighter",
          thStyle: {
            width: "3%"
          }
        },
        {
          key: "product",
          label: this.$t("ui.product"),
          class: "align-middle",
          thClass: "bg-grey-lighter",
          thStyle: {
            width: "10%"
          }
        },
        {
          key: "bet_count",
          label: this.$t("ui.bet_count"),
          class: "align-middle text-center",
          thClass: "bg-grey-lighter",
          thStyle: {
            width: "6%"
          }
        },
        {
          key: "turnover",
          label: this.$t("ui.turnover"),
          // sortable: true,
          class: "align-middle text-right",
          thClass: "bg-grey-lighter",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "valid_turnover",
          label: this.$t("ui.valid_turnover"),
          // sortable: true,
          class: "align-middle text-right",
          thClass: "bg-grey-lighter",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "gross_comm",
          label: this.$t("ui.gross_commission"),
          // sortable: true,
          class: "align-middle text-right",
          thClass: "bg-grey-lighter",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "member_winlose",
          label: this.$t("ui.winlose_column1"),
          // sortable: true,
          class: "align-middle text-right",
          thClass: "bg-grey-transparent-1",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "member_comm",
          label: this.$t("ui.winlose_column2"),
          // sortable: true,
          class: "align-middle text-right",
          thClass: "bg-grey-transparent-1",
          thStyle: {
            width: "7%"
          }
        },
        {
          key: "member_winlose_comm",
          label: this.$t("ui.total"),
          // sortable: true,
          class: "align-middle text-right bg-yellow-transparent-2",
          thClass: "bg-yellow-transparent-2",
          thStyle: {
            width: "7%"
          }
        }
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    },
    grandTotalBetCount() {
      return this.sumGrandTotal("bet_count")
    },
    grandTotalTurnover() {
      return this.sumGrandTotal("turnover")
    },
    grandTotalValidTurnover() {
      return this.sumGrandTotal("valid_turnover")
    },
    grandTotalGrossCommission() {
      return this.sumGrandTotal("gross_comm")
    },
    grandTotalMemberWinlose() {
      return this.sumGrandTotal("member_winlose")
    },
    grandTotalMemberCommission() {
      return this.sumGrandTotal("member_comm")
    },
    grandTotalMemberWinloseCommission() {
      return this.sumGrandTotal("member_winlose_comm")
    }
  },
  methods: {
    show: function(level) {
      return this.downlineLevel >= level ? '' : 'd-none'
    },
    sumGrandTotal: function(item) {
      let sum = 0
      this.list.forEach(value => {
        sum = sum + value[item];
      })
      return sum
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize)
      this.currentPage = 1
      this.submit()
    },
    getSportTypeWinlose: function(item) {
      this.$store.dispatch("layout/setPlatform", item.product)
      this.$emit("clicked")
    }
  }
}

</script>